import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {VideoItemObject} from '@PosterWhiteboard/items/video-item/video-item.class';

export function useGetKeyFromActiveVideoItem<T extends keyof VideoItemObject>(key: T): VideoItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];
    const copyItem = item as VideoItemObject;
    if (copyItem?.[key] !== undefined) {
      return copyItem[key];
    }

    return undefined;
  });
}
